import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';
import { brandPrimary, brandPrimaryActive, brandPrimaryHover, header } from '../../../../styles/colors';

const { spacing, typography } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
	},
	section: {
		marginTop: spacing.sm,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: spacing.sm,
	},
	detailsSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
		padding: spacing.md,
	},
	detailRow: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	label: {
		// header (#858585) has no exact THEME token; retained to avoid shifting the label color.
		color: header,
		fontSize: 13,
		fontWeight: typography.fontWeights.bold,
	},
	value: {
		fontSize: 13,
	},
	quickActions: {
		display: 'flex',
		gap: spacing.sm,
		justifyContent: 'center',
	},
	quickActionButton: {
		// brand* (#0466FF / #0142A5 / #00CCFF) predate the THEME palette and have no exact tokens;
		// retained as a cohesive set to keep the action button's colors unchanged.
		':active': {
			background: brandPrimaryActive,
		},
		':hover': {
			background: brandPrimaryHover,
		},
		alignItems: 'center',
		background: brandPrimary,
		borderRadius: '50%',
		cursor: 'pointer',
		display: 'flex',
		height: spacing.xxl,
		justifyContent: 'center',
		width: spacing.xxl,
	},
});
